import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_UserGroupHierarchy_Search_Fields: {[id:string]: ISearchProviderField } =
    {
        WB_USRGRPH_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'User Group Hierarchy WB Id',  columnResourceName: 'colUsrGrpHWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
        USRGRPH_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'User Group Hierarchy Id',     columnResourceName: 'colUsrGrpHId',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
        USRGRPH_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'User Group Hierarchy Name',   columnResourceName: 'colUsrGrpHName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
        MDSET_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'MD Set',   columnResourceName: 'colUsrGrpHMDset',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
        SALESORG_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Sales Org',   columnResourceName: 'colUsrGrpHSalesOrg',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
        CREATED_DTTS: {
            type: SearchProviderFieldType.sapdate,
            renderOptions: {
                columnName: 'Created Date',
                columnResourceName: 'colCreateDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM-dd-yy"
            },
            domainOptions: {}
        },
        MODIFIED_DTTS: {
            type: SearchProviderFieldType.sapdate,
            renderOptions: {
                columnName: 'Modified Date',
                columnResourceName: 'colModifiedDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM-dd-yy"
            },
            domainOptions: {}
        }
       }

const UserGroupSearchProviderBasic: ISearchProvider =
    {
        keyFields: {id:    'WB_USRGRPH_ID',
            id_ui: 'USRGRPH_ID',
            name:  'USRGRPH_NAME'},


        searchProviderFields: vUI_UserGroupHierarchy_Search_Fields,

        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_UserGroupHierarchy_Search',
                    this.searchProviderFields,
                    [])

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {

                        resolve(res)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        }

    }

const UserGroupHierarchySearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "UserGroupHierarchySearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'User Group Hierarchy Id',     searchProviderFieldId: 'USRGRPH_ID',   renderOptions: { }},
        {profileFilterName: 'User Group Hierarchy Name',   searchProviderFieldId: 'USRGRPH_NAME', renderOptions: { }},

    ],  // ISearchFields
    profileDisplayFields: [
        'USRGRPH_ID','USRGRPH_NAME', 'MDSET_NAME','SALESORG_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: UserGroupSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const UserGroupHierarchySearch: ISearch = {
    searchName: "Find User Group Hierarchy",
    renderOptions: { ui5ResourceId: "UserGroupHierarchySearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [UserGroupHierarchySearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("UserGroupHierarchyBO", "UserGroupHierarchy", UserGroupHierarchySearch, "User Group Hierarchy Search")

export {UserGroupHierarchySearch}